// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type MediaDetailAnalyticsQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  topicElementId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type MediaDetailAnalyticsQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { media: (
      { __typename?: 'AnalyticsMediaModel' }
      & Pick<PrivateSchemaTypes.AnalyticsMediaModel, 'averageEngagement' | 'playsCount' | 'impressionsCount' | 'playRate' | 'playTimeMinutes'>
      & { uniquePlaysCount: PrivateSchemaTypes.AnalyticsMediaModel['playsCount'], uniqueImpressionsCount: PrivateSchemaTypes.AnalyticsMediaModel['impressionsCount'], uniquePlayRate: PrivateSchemaTypes.AnalyticsMediaModel['playRate'] }
      & { topicElement?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModel' }
        & Pick<PrivateSchemaTypes.TopicElementModel, 'id' | 'data' | 'duration' | 'type' | 'order' | 'mediaFileName' | 'created_at' | 'deleted_at'>
        & { documents: Array<(
          { __typename?: 'VideoDocument' }
          & Pick<PrivateSchemaTypes.VideoDocument, 'id' | 'status' | 'fileUrl' | 'cdnUrl' | 'mimeType'>
        )>, topicVersion: (
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id'>
          & { topic: (
            { __typename?: 'TopicModel' }
            & Pick<PrivateSchemaTypes.TopicModel, 'id' | 'currentTitle' | 'deleted_at'>
          ) }
        ) }
      )>, impressionsByTimeUnit: Array<(
        { __typename?: 'AnalyticsHitCountByTimeUnit' }
        & Pick<PrivateSchemaTypes.AnalyticsHitCountByTimeUnit, 'day' | 'count'>
      )>, onlyEngagementsByTimeUnit: Array<(
        { __typename?: 'AnalyticsHitCountByTimeUnit' }
        & Pick<PrivateSchemaTypes.AnalyticsHitCountByTimeUnit, 'day' | 'count'>
      )> }
    ) }
  ) }
);

export type MediaDetailImpressionsOverviewQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  overviewTableFilter: PrivateSchemaTypes.AnalyticsMediaImpressionsOverviewFilter;
  topicElementId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type MediaDetailImpressionsOverviewQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { media: (
      { __typename?: 'AnalyticsMediaModel' }
      & { impressionsOverview?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'AnalyticsMediaImpressionsOverviewModel' }
        & Pick<PrivateSchemaTypes.AnalyticsMediaImpressionsOverviewModel, 'count'>
        & { items: Array<(
          { __typename?: 'VideoImpressionModelAsAdmin' }
          & Pick<PrivateSchemaTypes.VideoImpressionModelAsAdmin, 'id' | 'total_play_time_ms' | 'lastActiveAt' | 'engagementPercent'>
          & { topicEnrolment: (
            { __typename?: 'TopicEnrolmentModelAsEditor' }
            & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsEditor, 'id'>
            & { user: (
              { __typename?: 'UserModel' }
              & Pick<PrivateSchemaTypes.UserModel, 'id' | 'display_name'>
            ) }
          ) }
        )> }
      )> }
    ) }
  ) }
);

export type MediaDetailCsvQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  overviewTableFilter: PrivateSchemaTypes.AnalyticsMediaImpressionsOverviewFilter;
  topicElementId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type MediaDetailCsvQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { media: (
      { __typename?: 'AnalyticsMediaModel' }
      & { impressionsOverview?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'AnalyticsMediaImpressionsOverviewModel' }
        & { items: Array<(
          { __typename?: 'VideoImpressionModelAsAdmin' }
          & Pick<PrivateSchemaTypes.VideoImpressionModelAsAdmin, 'id' | 'total_play_time_ms' | 'lastActiveAt' | 'total_unique_play_time_ms' | 'finished_at' | 'engagementPercent' | 'created_at' | 'deleted_at'>
          & { topicEnrolment: (
            { __typename?: 'TopicEnrolmentModelAsEditor' }
            & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsEditor, 'id'>
            & { user: (
              { __typename?: 'UserModel' }
              & Pick<PrivateSchemaTypes.UserModel, 'id' | 'display_name'>
            ) }
          ) }
        )> }
      )> }
    ) }
  ) }
);

export type MediaDetailVideoDurationQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  topicElementId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type MediaDetailVideoDurationQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { media: (
      { __typename?: 'AnalyticsMediaModel' }
      & { impressionsOverview?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'AnalyticsMediaImpressionsOverviewModel' }
        & Pick<PrivateSchemaTypes.AnalyticsMediaImpressionsOverviewModel, 'count'>
        & { items: Array<(
          { __typename?: 'VideoImpressionModelAsAdmin' }
          & Pick<PrivateSchemaTypes.VideoImpressionModelAsAdmin, 'id' | 'video_duration_ms'>
        )> }
      )> }
    ) }
  ) }
);

export type MediaDetailEngagementChartQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  topicElementId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type MediaDetailEngagementChartQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { media: (
      { __typename?: 'AnalyticsMediaModel' }
      & { impressionsOverview?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'AnalyticsMediaImpressionsOverviewModel' }
        & Pick<PrivateSchemaTypes.AnalyticsMediaImpressionsOverviewModel, 'count'>
        & { items: Array<(
          { __typename?: 'VideoImpressionModelAsAdmin' }
          & Pick<PrivateSchemaTypes.VideoImpressionModelAsAdmin, 'id' | 'userId'>
          & { engagements: Array<(
            { __typename?: 'VideoEngagement' }
            & { from: PrivateSchemaTypes.VideoEngagement['from_time_ms'], to: PrivateSchemaTypes.VideoEngagement['to_time_ms'] }
          )> }
        )> }
      )> }
    ) }
  ) }
);


export const MediaDetailAnalyticsDocument = gql`
    query mediaDetailAnalytics($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $topicElementId: PositiveInt!) {
  analytics(filter: $mainAnalyticsFilter) {
    media {
      topicElement(id: $topicElementId) {
        id
        data
        duration
        type
        order
        documents {
          id
          status
          fileUrl
          cdnUrl
          mimeType
        }
        mediaFileName
        created_at
        deleted_at
        topicVersion {
          id
          topic {
            id
            currentTitle
            deleted_at
          }
        }
      }
      averageEngagement
      playsCount
      uniquePlaysCount: playsCount(onlyUnique: true)
      impressionsCount
      uniqueImpressionsCount: impressionsCount(onlyUnique: true)
      playRate
      uniquePlayRate: playRate(onlyUnique: true)
      playTimeMinutes
      impressionsByTimeUnit: impressionsByTimeUnit(unit: DAY, onlyEngagements: false) {
        day
        count
      }
      onlyEngagementsByTimeUnit: impressionsByTimeUnit(
        unit: DAY
        onlyEngagements: true
      ) {
        day
        count
      }
    }
  }
}
    `;

/**
 * __useMediaDetailAnalyticsQuery__
 *
 * To run a query within a React component, call `useMediaDetailAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaDetailAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaDetailAnalyticsQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      topicElementId: // value for 'topicElementId'
 *   },
 * });
 */
export function useMediaDetailAnalyticsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MediaDetailAnalyticsQuery, MediaDetailAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MediaDetailAnalyticsQuery, MediaDetailAnalyticsQueryVariables>(MediaDetailAnalyticsDocument, options);
      }
export function useMediaDetailAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaDetailAnalyticsQuery, MediaDetailAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MediaDetailAnalyticsQuery, MediaDetailAnalyticsQueryVariables>(MediaDetailAnalyticsDocument, options);
        }
export type MediaDetailAnalyticsQueryHookResult = ReturnType<typeof useMediaDetailAnalyticsQuery>;
export type MediaDetailAnalyticsLazyQueryHookResult = ReturnType<typeof useMediaDetailAnalyticsLazyQuery>;
export type MediaDetailAnalyticsQueryResult = Apollo.QueryResult<MediaDetailAnalyticsQuery, MediaDetailAnalyticsQueryVariables>;
export const MediaDetailImpressionsOverviewDocument = gql`
    query mediaDetailImpressionsOverview($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $overviewTableFilter: AnalyticsMediaImpressionsOverviewFilter!, $topicElementId: PositiveInt!) {
  analytics(filter: $mainAnalyticsFilter) {
    media {
      impressionsOverview(
        topicElementId: $topicElementId
        overviewTableFilter: $overviewTableFilter
      ) {
        items {
          id
          total_play_time_ms
          lastActiveAt
          engagementPercent
          topicEnrolment {
            id
            user {
              id
              display_name
            }
          }
        }
        count
      }
    }
  }
}
    `;

/**
 * __useMediaDetailImpressionsOverviewQuery__
 *
 * To run a query within a React component, call `useMediaDetailImpressionsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaDetailImpressionsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaDetailImpressionsOverviewQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      overviewTableFilter: // value for 'overviewTableFilter'
 *      topicElementId: // value for 'topicElementId'
 *   },
 * });
 */
export function useMediaDetailImpressionsOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MediaDetailImpressionsOverviewQuery, MediaDetailImpressionsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MediaDetailImpressionsOverviewQuery, MediaDetailImpressionsOverviewQueryVariables>(MediaDetailImpressionsOverviewDocument, options);
      }
export function useMediaDetailImpressionsOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaDetailImpressionsOverviewQuery, MediaDetailImpressionsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MediaDetailImpressionsOverviewQuery, MediaDetailImpressionsOverviewQueryVariables>(MediaDetailImpressionsOverviewDocument, options);
        }
export type MediaDetailImpressionsOverviewQueryHookResult = ReturnType<typeof useMediaDetailImpressionsOverviewQuery>;
export type MediaDetailImpressionsOverviewLazyQueryHookResult = ReturnType<typeof useMediaDetailImpressionsOverviewLazyQuery>;
export type MediaDetailImpressionsOverviewQueryResult = Apollo.QueryResult<MediaDetailImpressionsOverviewQuery, MediaDetailImpressionsOverviewQueryVariables>;
export const MediaDetailCsvDocument = gql`
    query mediaDetailCSV($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $overviewTableFilter: AnalyticsMediaImpressionsOverviewFilter!, $topicElementId: PositiveInt!) {
  analytics(filter: $mainAnalyticsFilter) {
    media {
      impressionsOverview(
        topicElementId: $topicElementId
        overviewTableFilter: $overviewTableFilter
      ) {
        items {
          id
          total_play_time_ms
          lastActiveAt
          total_unique_play_time_ms
          finished_at
          engagementPercent
          created_at
          deleted_at
          topicEnrolment {
            id
            user {
              id
              display_name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMediaDetailCsvQuery__
 *
 * To run a query within a React component, call `useMediaDetailCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaDetailCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaDetailCsvQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      overviewTableFilter: // value for 'overviewTableFilter'
 *      topicElementId: // value for 'topicElementId'
 *   },
 * });
 */
export function useMediaDetailCsvQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MediaDetailCsvQuery, MediaDetailCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MediaDetailCsvQuery, MediaDetailCsvQueryVariables>(MediaDetailCsvDocument, options);
      }
export function useMediaDetailCsvLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaDetailCsvQuery, MediaDetailCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MediaDetailCsvQuery, MediaDetailCsvQueryVariables>(MediaDetailCsvDocument, options);
        }
export type MediaDetailCsvQueryHookResult = ReturnType<typeof useMediaDetailCsvQuery>;
export type MediaDetailCsvLazyQueryHookResult = ReturnType<typeof useMediaDetailCsvLazyQuery>;
export type MediaDetailCsvQueryResult = Apollo.QueryResult<MediaDetailCsvQuery, MediaDetailCsvQueryVariables>;
export const MediaDetailVideoDurationDocument = gql`
    query mediaDetailVideoDuration($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $topicElementId: PositiveInt!) {
  analytics(filter: $mainAnalyticsFilter) {
    media {
      impressionsOverview(
        topicElementId: $topicElementId
        overviewTableFilter: {page: 1, limit: 1}
      ) {
        items {
          id
          video_duration_ms
        }
        count
      }
    }
  }
}
    `;

/**
 * __useMediaDetailVideoDurationQuery__
 *
 * To run a query within a React component, call `useMediaDetailVideoDurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaDetailVideoDurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaDetailVideoDurationQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      topicElementId: // value for 'topicElementId'
 *   },
 * });
 */
export function useMediaDetailVideoDurationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MediaDetailVideoDurationQuery, MediaDetailVideoDurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MediaDetailVideoDurationQuery, MediaDetailVideoDurationQueryVariables>(MediaDetailVideoDurationDocument, options);
      }
export function useMediaDetailVideoDurationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaDetailVideoDurationQuery, MediaDetailVideoDurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MediaDetailVideoDurationQuery, MediaDetailVideoDurationQueryVariables>(MediaDetailVideoDurationDocument, options);
        }
export type MediaDetailVideoDurationQueryHookResult = ReturnType<typeof useMediaDetailVideoDurationQuery>;
export type MediaDetailVideoDurationLazyQueryHookResult = ReturnType<typeof useMediaDetailVideoDurationLazyQuery>;
export type MediaDetailVideoDurationQueryResult = Apollo.QueryResult<MediaDetailVideoDurationQuery, MediaDetailVideoDurationQueryVariables>;
export const MediaDetailEngagementChartDocument = gql`
    query mediaDetailEngagementChart($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $topicElementId: PositiveInt!) {
  analytics(filter: $mainAnalyticsFilter) {
    media {
      impressionsOverview(
        topicElementId: $topicElementId
        overviewTableFilter: {onlyEngagements: true}
      ) {
        items {
          id
          userId
          engagements {
            from: from_time_ms
            to: to_time_ms
          }
        }
        count
      }
    }
  }
}
    `;

/**
 * __useMediaDetailEngagementChartQuery__
 *
 * To run a query within a React component, call `useMediaDetailEngagementChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaDetailEngagementChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaDetailEngagementChartQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      topicElementId: // value for 'topicElementId'
 *   },
 * });
 */
export function useMediaDetailEngagementChartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MediaDetailEngagementChartQuery, MediaDetailEngagementChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MediaDetailEngagementChartQuery, MediaDetailEngagementChartQueryVariables>(MediaDetailEngagementChartDocument, options);
      }
export function useMediaDetailEngagementChartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaDetailEngagementChartQuery, MediaDetailEngagementChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MediaDetailEngagementChartQuery, MediaDetailEngagementChartQueryVariables>(MediaDetailEngagementChartDocument, options);
        }
export type MediaDetailEngagementChartQueryHookResult = ReturnType<typeof useMediaDetailEngagementChartQuery>;
export type MediaDetailEngagementChartLazyQueryHookResult = ReturnType<typeof useMediaDetailEngagementChartLazyQuery>;
export type MediaDetailEngagementChartQueryResult = Apollo.QueryResult<MediaDetailEngagementChartQuery, MediaDetailEngagementChartQueryVariables>;